import { render, staticRenderFns } from "./ThankYou.vue?vue&type=template&id=53c0ad3d"
import script from "./ThankYou.vue?vue&type=script&lang=ts"
export * from "./ThankYou.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports